export default __webpack_public_path__ + "static/media/colocado-10.3a324ff9.jpg";